export default {
    // sessionStorage
    set (key, value) {
        window.sessionStorage.setItem(key, JSON.stringify(value));
    },
    get(key) {
        // return window.sessionStorage.getItem(key) ? JSON.parse(window.sessionStorage.getItem(key)) : null;
        if(window.sessionStorage.getItem(key)){
            try{
                JSON.parse(window.sessionStorage.getItem(key));
                return JSON.parse(window.sessionStorage.getItem(key));
            }catch(e){
                JSON.parse(JSON.stringify(window.sessionStorage.getItem(key)));
                return JSON.parse(JSON.stringify(window.sessionStorage.getItem(key)));
            }
        }else{
            return null
        }
    },
    // 清除除companyNo外的所有cookie
    cookieClear() {
        let companyNo = this.get("companyNo");
        if(!companyNo) return;
        sessionStorage.removeItem(companyNo+"_token");
        sessionStorage.removeItem(companyNo+"_userInfo");
    },
    formatDate (timestamp, format) {
        var dd = new Date();
        if (typeof timestamp !== 'undefined') {
            dd.setTime(timestamp);
        }
        if (typeof format === 'undefined') {
            format = "yyyy-MM-dd";
        }
        var o = {
            "M+": dd.getMonth() + 1, //month
            "d+": dd.getDate(),    //day
            "h+": dd.getHours(),   //hour
            "m+": dd.getMinutes(), //minute
            "s+": dd.getSeconds(), //second
            "q+": Math.floor((dd.getMonth() + 3) / 3),  //quarter
            "S": dd.getMilliseconds() //millisecond
        };
        if (/(y+)/.test(format))
            format = format.replace(RegExp.$1,
                (dd.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o)
            if (new RegExp("(" + k + ")").test(format))
                format = format.replace(RegExp.$1,
                    RegExp.$1.length == 1 ? o[k] :
                        ("00" + o[k]).substr(("" + o[k]).length));
        return format;
    },
}


// WEBPACK FOOTER //
// ./src/utils/util.js